export default "__VITE_ASSET__MYxj6wBo__"